import React from 'react';

const LOGO_URL = '/media/landing/logo.webp';

export const MyCompanionLogo = ({ size = 'md', className = '' }) => {
  const sizes = {
    sm: 'h-10 w-10',
    md: 'h-14 w-14 sm:h-16 sm:w-16',
    lg: 'h-20 w-20 sm:h-24 sm:w-24',
    xl: 'h-28 w-28 sm:h-32 sm:w-32 lg:h-40 lg:w-40',
  };
  const s = sizes[size] || sizes.md;

  return (
    <img
      src={LOGO_URL}
      alt="MyCompanion AI"
      className={`${s} object-contain rounded-2xl ${className}`}
      data-testid="mycompanion-logo"
      draggable={false}
    />
  );
};
